import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Table from '../Table';
import moment from 'moment';

export const ServiceRequestStatsTable = ({ reports }) => {
  if (!reports || reports.length === 0) return <></>;

  return (
    <div
      id="serviceRequestTableScrollableDiv"
      style={{
        height: 500,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <InfiniteScroll
        dataLength={reports?.length}
        style={{ display: 'flex', flexDirection: 'column' }}
        inverse={false}
        scrollableTarget="serviceRequestTableScrollableDiv"
      >
        <Table
          columns={[
            {
              sortable: false,
              label: 'Property Name',
              cell: (data) => {
                return data.propertyName;
              },
            },
            {
              sortable: false,
              label: 'Suite Number',
              cell: (data) => {
                return data.suiteNumber;
              },
            },
            {
              sortable: false,
              label: 'Suite Civic Address',
              cell: (data) => {
                return data.suiteAddress;
              },
            },
            {
              sortable: false,
              label: 'Ticket Number',
              cell: (data) => {
                return data.ticketNumber;
              },
            },
            {
              sortable: false,
              label: 'Submitted Date',
              cell: (data) => {
                return moment(data.submittedDate).format('DD/MM/YYYY');
              },
            },
            {
              sortable: false,
              label: 'Last Updated',
              cell: (data) => {
                return moment(data.lastUpdated).year() > 2000
                  ? moment(data.lastUpdated).format('DD/MM/YYYY')
                  : '';
              },
            },
            {
              sortable: false,
              label: 'Status',
              cell: (data) => data.status,
            },
            {
              sortable: false,
              label: 'Days Open',
              cell: (data) => data.daysOpen,
            },
          ]}
          data={reports}
        />
      </InfiniteScroll>
    </div>
  );
};
